import { render, staticRenderFns } from "./companyNewsDetail.vue?vue&type=template&id=44ed910a&scoped=true"
import script from "./companyNewsDetail.vue?vue&type=script&lang=js"
export * from "./companyNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./companyNewsDetail.vue?vue&type=style&index=0&id=44ed910a&prod&lang=scss"
import style1 from "./companyNewsDetail.vue?vue&type=style&index=1&id=44ed910a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed910a",
  null
  
)

export default component.exports